<div class="full-width" fxLayout="column">
  <div class="info-card p-4 body-1-regular-1" fxLayout="column" fxLayoutGap="20px" fxFlexOffset="20px">
    <div fxLayout="row">
      <span class="subtitle-default">Error Trading Report</span>
    </div>

    <div fxLayout="column">
      <span class="heading-bold">What happened?</span>
      <span>We have found some sales which have not been linked to any particular tenant.</span>
      <span>Without this crucial link we cannot determine who this money must be paid out to.</span>
    </div>

    <div fxLayout="column">
      <span class="heading-bold">Unlinked products:</span>
      <span>This can be caused by a product not being linked to a supplier in the point-of-sale software.</span>
      <span>This will typically result in a sale not being linked to a product and so the name and SKU will not be displayed beside the sale below.</span>
    </div>

    <div fxLayout="column">
      <span class="heading-bold">How to fix unlinked products:</span>
      <span>If this is the case please go to the point-of-sale account for the given config and ensure all products are linked to a supplier.</span>
    </div>

    <div fxLayout="column">
      <span class="heading-bold">Unlinked suppliers:</span>
      <span>This can also be caused by a supplier in the point-of-sale software not being linked to a lease on our platform.</span>
      <span>This will typically result in a sale being linked to a product, but not a tenant.</span>
      <span>If this is the case please ensure that all leases trading under this config are linked to a supplier on this platform.</span>
    </div>

    <div fxLayout="column">
      <span class="heading-bold">How to fix unlinked suppliers:</span>
      <span>This can be done on a lease's details page, under the "Point-of-sale Settings" section.</span>
      <span *ngIf="paymentMethodType == 'OFFERING'">You can check any unassigned suppliers by going to the "Payments" tab, selecting the relevant config, and clicking the "Linked Suppliers" button.</span>
      <span *ngIf="paymentMethodType == 'SHARED'">You can check any unassigned suppliers by going to parent lease, selecting the relevant config, and clicking the "Linked Suppliers" button.</span>
    </div>

    <div fxLayout="column">
      <span class="heading-bold">After you've fixed the data:</span>
      <span>Once you have corrected the information, click the "Fix Errors" button which will reprocess the product, supplier and sales data.</span>
      <span>Please allow a few minutes for the data to be processed.</span>
    </div>

  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlexOffset="30px">
    <span class="subtitle-default"> Unlinked amount received</span>
    <span class="fx-spacer"></span>
    <button
      mat-icon-button
      [matMenuTriggerFor]="summaryMainOptionsMenu"
      matTooltip="Table options"
      [disabled]="!!(loader.loading$ | async)"
    >
      <mat-icon class="crud-table-main-toolbar-icon">more_vert</mat-icon>
    </button>
    <mat-menu #summaryMainOptionsMenu="matMenu">
      <!-- Export to CSV -->
      <button mat-menu-item (click)="exportToCsv('summary')">
        <mat-icon>file_download</mat-icon>
        <span>Export to CSV</span>
      </button>

      <!-- Export to Excel -->
      <button mat-menu-item (click)="exportToExcel('summary')">
        <mat-icon>file_download</mat-icon>
        <span>Export to Excel</span>
      </button>

      <!-- Export to PDF -->
      <button mat-menu-item (click)="exportToPdf('summary')">
        <mat-icon>file_download</mat-icon>
        <span>Export to PDF</span>
      </button>

    </mat-menu>
  </div>

  <div class="mat-elevation-z radius-10 bg-white3" fxLayout="column" fxFlexOffset="10px">
    <table mat-table class="custom-table chart-table" [dataSource]="errorSummaryDatasource"
           matSort matSortActive="transactionDate" matSortDirection="desc" #sort1="matSort">
      <ng-container matColumnDef="table-label">
        <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="summaryColumns.length"> Amount per day which could not be linked to a tenant. </th>
      </ng-container>

      <ng-container matColumnDef="transactionDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Trading Date </th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{dateUtils.displayDateWithTime(element.transactionDate)}} </td>
        <td mat-footer-cell *matFooterCellDef><span class="heading-default"><strong>Totals:</strong></span></td>

      </ng-container>

      <ng-container matColumnDef="paymentMethod">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Payment Method </th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{utils.displayStatus(element.paymentMethod)}} </td>
        <td mat-footer-cell *matFooterCellDef></td>

      </ng-container>

      <ng-container matColumnDef="amountReceived">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount Received </th>
        <td mat-cell class="custom-table-cell btn-cursor" *matCellDef="let element"> {{utils.displayRandAmountWithDecimal(element.amountReceived)}} </td>
        <td mat-footer-cell *matFooterCellDef><span
          class="heading-default">{{utils.displayRandAmountWithDecimal(getSummaryAmountReceivedTotal())}}</span></td>
      </ng-container>

      <ng-container matColumnDef="errorCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Error Count </th>
        <td mat-cell class="custom-table-cell btn-cursor" *matCellDef="let element"> {{utils.displayNumber(element.errorCount)}} </td>
        <td mat-footer-cell *matFooterCellDef>{{getErrorCountTotal()}}</td>

      </ng-container>

      <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
      <tr mat-header-row class="custom-table-header" *matHeaderRowDef="summaryColumns"></tr>
      <tr mat-row class="custom-table-row" *matRowDef="let row; columns: summaryColumns;"></tr>
      <!-- Footer Row -->
      <tr mat-footer-row *matFooterRowDef="summaryColumns"></tr>
    </table>
    <mat-paginator #paginator1 class="custom-paginator"
                   [length]="errorSummaryDatasource.data.length"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   [pageSize]="10"></mat-paginator>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlexOffset="30px">
    <span class="subtitle-default"> Error sales </span>
    <span class="fx-spacer"></span>
    <button
      mat-icon-button
      [matMenuTriggerFor]="errorMainOptionsMenu"
      matTooltip="Table options"
      [disabled]="!!(loader.loading$ | async)"
    >
      <mat-icon class="crud-table-main-toolbar-icon">more_vert</mat-icon>
    </button>
    <mat-menu #errorMainOptionsMenu="matMenu">
      <!-- Export to CSV -->
      <button mat-menu-item (click)="exportToCsv('error')">
        <mat-icon>file_download</mat-icon>
        <span>Export to CSV</span>
      </button>

      <!-- Export to Excel -->
      <button mat-menu-item (click)="exportToExcel('error')">
        <mat-icon>file_download</mat-icon>
        <span>Export to Excel</span>
      </button>

      <!-- Export to PDF -->
      <button mat-menu-item (click)="exportToPdf('error')">
        <mat-icon>file_download</mat-icon>
        <span>Export to PDF</span>
      </button>
    </mat-menu>
  </div>

  <div class="mat-elevation-z3 radius-10 bg-white" fxLayout="column" fxFlexOffset="10px">
    <table mat-table class="custom-table chart-table" [dataSource]="errorReportDatasource"
           matSort matSortActive="transactionDate" matSortDirection="desc" #sort2="matSort">
      <ng-container matColumnDef="table-label">
        <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="reportColumns.length"> Error sales </th>
      </ng-container>

      <ng-container matColumnDef="transactionDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Trading Date </th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{dateUtils.displayShortDate(element.transactionDate)}} </td>
        <td mat-footer-cell *matFooterCellDef><span class="heading-default"><strong>Totals:</strong></span></td>

      </ng-container>

      <ng-container matColumnDef="transactionInvoiceNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Number </th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{utils.displayString(element.transactionInvoiceNumber, 50)}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="productName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product Name </th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{utils.displayString(element.productName, 50)}} </td>
        <td mat-footer-cell *matFooterCellDef></td>

      </ng-container>

      <ng-container matColumnDef="productSku">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Product SKU </th>
        <td mat-cell class="custom-table-cell btn-cursor" *matCellDef="let element"> {{element.productSku}} </td>
        <td mat-footer-cell *matFooterCellDef></td>

      </ng-container>

      <ng-container matColumnDef="amountReceived">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount Received </th>
        <td mat-cell class="custom-table-cell btn-cursor" *matCellDef="let element"> {{utils.displayRandAmountWithDecimal(element.amountReceived)}} </td>
        <td mat-footer-cell *matFooterCellDef><span
          class="heading-default">{{utils.displayRandAmountWithDecimal(getErrorAmountReceivedTotal())}}</span></td>

      </ng-container>

      <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
      <tr mat-header-row class="custom-table-header" *matHeaderRowDef="reportColumns"></tr>
      <tr mat-row class="custom-table-row" *matRowDef="let row; columns: reportColumns;"></tr>
      <!-- Footer Row -->
      <tr mat-footer-row *matFooterRowDef="reportColumns"></tr>
    </table>
    <mat-paginator #paginator2 class="custom-paginator"
                   [length]="errorReportDatasource.data.length"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   [pageSize]="10"></mat-paginator>
  </div>
</div>
